export default "__VITE_ASSET__CPgTABCN__"